import { c as _c } from "react/compiler-runtime";
import { SvgChevronright } from '@common/icon';
import { POINT_ACTIVITY } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { ROUTES } from '@/constants';
interface PointHistoryCardProps {
  date: string;
  point: number;
  title: string;
  description: string;
  contentIdx?: string;
  pointActivity: string;
}
const getHref = ({
  pointActivity,
  contentIdx
}: Pick<PointHistoryCardProps, 'pointActivity' | 'contentIdx'>): string | undefined => {
  const idIdx = contentIdx ?? '';
  const commentDetailRoutes: Record<string, typeof ROUTES.POLICY_INFO_DETAIL> = {
    [POINT_ACTIVITY.BEST_CONTENTS_COMMENT_WRITE]: ROUTES.POLICY_INFO_DETAIL,
    [POINT_ACTIVITY.HOMETOWN_NEWS_COMMENT_WRITE]: ROUTES.HOMETOWN_NEWS_DETAIL
  };
  const detailRoute = commentDetailRoutes[pointActivity];
  if (detailRoute) {
    return detailRoute.pathname({
      idIdx
    });
  }
  const directRoutes: Record<string, string> = {};
  return directRoutes[pointActivity];
};
export const PointHistoryCard = t0 => {
  const $ = _c(27);
  const {
    date,
    point,
    title,
    description,
    contentIdx,
    pointActivity
  } = t0;
  let t1;
  if ($[0] !== contentIdx || $[1] !== pointActivity) {
    t1 = getHref({
      pointActivity,
      contentIdx
    });
    $[0] = contentIdx;
    $[1] = pointActivity;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const href = t1;
  let t2;
  if ($[3] !== date) {
    t2 = <p className="w-50 shrink-0 typo-caption1">{date}</p>;
    $[3] = date;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== title) {
    t3 = <p className="mb-2 font-500 text-Gray-900 typo-body3">{title}</p>;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== description) {
    t4 = <p className="text-Gray-600 typo-body4">{description}</p>;
    $[7] = description;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== href) {
    t5 = href ? <SvgChevronright className="size-14 text-Gray-600" /> : null;
    $[9] = href;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="w-fit gap-2 flex-center">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <div className="grow">{t3}{t6}</div>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== point) {
    t8 = <div className="flex shrink-0 items-center">{point > 0 ? <p className="font-600 text-B-500 typo-body3">{`+${point.toLocaleString()}`}P</p> : <p className="font-600 text-Gray-600 typo-body3">{point.toLocaleString()}P</p>}</div>;
    $[17] = point;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t2 || $[20] !== t7 || $[21] !== t8) {
    t9 = <>{t2}{t7}{t8}</>;
    $[19] = t2;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const children = t9;
  let t10;
  if ($[23] !== children || $[24] !== href || $[25] !== title) {
    t10 = <li>{href ? <CustomLink aria-label={title} className="flex border-b-1 border-Gray-200 px-20 py-16" href={href}>{children}</CustomLink> : <div aria-label={title} className="flex border-b-1 border-Gray-200 px-20 py-16">{children}</div>}</li>;
    $[23] = children;
    $[24] = href;
    $[25] = title;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};